import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {makeStyles} from '@material-ui/core'
import HealthCenterReportStyle from 'pages/HealthCenter/Report/Style'
import {isoStringToDateString} from 'helpers/dateHelper'
import {HeaderReportResponse} from 'api/languageApi'

const useStyles = makeStyles(HealthCenterReportStyle)

type PropsType = {
  title: string
  content: string
  name: string
  sex: string
  birthday: string
  measurementDate: string
  titleHeader: HeaderReportResponse | null
  tabIndex: number
}

const HeaderMultiLangReport = ({
  title,
  content,
  name,
  sex,
  birthday,
  measurementDate,
  titleHeader,
  tabIndex,
}: PropsType) => {
  const {t} = useTranslation()
  const classes = useStyles()

  const calculateAge = (birthDateString: string) => {
    const birthDate = new Date(birthDateString)
    const today = new Date()

    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age -= 1
    }

    return age
  }

  const TABLE = useMemo(() => {
    return [
      [titleHeader?.name?.title ?? t('IFirstName'), name],
      [titleHeader?.sex?.title ?? t('IGender'), sex],
      [
        titleHeader?.birth.title ?? t('IBirthday'),
        birthday
          ? `${birthday} (${calculateAge(birthday)}${t(
              'IEEGSummaryReportChildBrainAgeYear',
            )})`
          : '',
      ],
      [
        (tabIndex === 5
          ? titleHeader?.measurement.title.eeg
          : titleHeader?.measurement.title.hrv) ?? t('IMeasurementDate'),
        isoStringToDateString(measurementDate),
      ],
    ]
  }, [t, tabIndex, titleHeader, name, sex, birthday, measurementDate])

  return (
    <div className={classes.header}>
      <div className={classes.leftHeader}>
        <div className={classes.leftHeaderTitle}>{title}</div>
        <div className={classes.leftHeaderContent}>{content}</div>
      </div>
      <div className={classes.rightHeader}>
        <div className={classes.table}>
          {TABLE.map((item) => (
            <div className={classes.row} key={item[0]}>
              <div className={classes.headCell}>{item[0]}</div>
              <div
                className={classes.bodyCell}
                style={{
                  textAlign: 'center',
                }}
              >
                {item[1]}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
export default HeaderMultiLangReport
